import { bindRequestLogic } from './utils'
import Types from '../actionTypes/kitConfigurationVersionPers'
import { kitConfigurationVersionPersAPI } from '../api'

export const getListKitConfigurationVersionPers = bindRequestLogic({
  clientFunc: kitConfigurationVersionPersAPI.getListKitConfigurationVersionPers,
  type: Types.GET_LIST_KIT_CONFIGURATION_VERSION_PERS_REQUEST,
  successType: Types.GET_LIST_KIT_CONFIGURATION_VERSION_PERS_SUCCESS,
  failType: Types.GET_LIST_KIT_CONFIGURATION_VERSION_PERS_FAILED,
  isQueryParam: true
})

export const getDetailKitConfigurationVersionPers = bindRequestLogic({
  clientFunc:
    kitConfigurationVersionPersAPI.getDetailKitConfigurationVersionPers,
  type: Types.GET_DETAIL_KIT_CONFIGURATION_VERSION_PERS_REQUEST,
  successType: Types.GET_DETAIL_KIT_CONFIGURATION_VERSION_PERS_SUCCESS,
  failType: Types.GET_DETAIL_KIT_CONFIGURATION_VERSION_PERS_FAILED
})

export const deleteKitConfigurationVersionPers = bindRequestLogic({
  clientFunc: kitConfigurationVersionPersAPI.deleteKitConfigurationVersionPers,
  type: Types.DELETE_KIT_CONFIGURATION_VERSION_PERS_REQUEST,
  successType: Types.DELETE_KIT_CONFIGURATION_VERSION_PERS_SUCCESS,
  failType: Types.DELETE_KIT_CONFIGURATION_VERSION_PERS_FAILED
})

export const addKitConfigurationVersionPers = bindRequestLogic({
  clientFunc: kitConfigurationVersionPersAPI.addKitConfigurationVersionPers,
  type: Types.ADD_KIT_CONFIGURATION_VERSION_PERS_REQUEST,
  successType: Types.ADD_KIT_CONFIGURATION_VERSION_PERS_SUCCESS,
  failType: Types.ADD_KIT_CONFIGURATION_VERSION_PERS_FAILED
})

export const updateKitConfigurationVersionPers = bindRequestLogic({
  clientFunc: kitConfigurationVersionPersAPI.updateKitConfigurationVersionPers,
  type: Types.UPDATE_KIT_CONFIGURATION_VERSION_PERS_REQUEST,
  successType: Types.UPDATE_KIT_CONFIGURATION_VERSION_PERS_SUCCESS,
  failType: Types.UPDATE_KIT_CONFIGURATION_VERSION_PERS_FAILED
})

export default [
  getListKitConfigurationVersionPers,
  getDetailKitConfigurationVersionPers,
  deleteKitConfigurationVersionPers,
  addKitConfigurationVersionPers,
  updateKitConfigurationVersionPers
]
